import React, { createContext, useContext } from 'react';

interface IRowContext {
  horizontalSpacing: number;
}

const RowContext = createContext<IRowContext | undefined>(undefined);

export const RowContextProvider: React.FC<{
  children: React.ReactNode;
  horizontalSpacing: number;
}> = ({ children, horizontalSpacing }) => {
  return (
    <RowContext.Provider value={{ horizontalSpacing }}>
      {children}
    </RowContext.Provider>
  );
};

export const useRowContext = () => {
  const context = useContext(RowContext);
  return context;
};
